module.exports = __webpack_public_path__ + "static/media/ruspolia_nitidula.14209465.mp3";